import 'dayjs/locale/el'
import { Dayjs } from 'dayjs'

const el = {
  calendar: {
    sameDay: '[Σήμερα {}] LT',
    nextDay: '[Αύριο {}] LT',
    nextWeek: 'dddd [{}] LT',
    lastDay: '[Χθες {}] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 6:
          return now.format('[το προηγούμενο] dddd [{}] LT')
        default:
          return now.format('[την προηγούμενη] dddd [{}] LT')
      }
    },
    sameElse: 'L'
  }
}

export default el
